import api from '.';
import { PipingModelType } from '../pages/MasterData/PipingModelType/pipingModelTypeSlice';

interface ReturnTypePipingModelType {
  data: PipingModelType[];
}

export async function getPipingModelTypes(): Promise<ReturnTypePipingModelType> {
  const { data } = await api.get('/piping-model-types');

  return data;
}
